import { useEffect } from 'react';

// third-party
import { Provider as ReduxProvider } from 'react-redux';

// project-imports
import Routes from './routes';
import ThemeCustomization from './themes';
import { Toaster } from './components/ui/toaster';
import { store } from './store';
import { initializeAuth } from './store/thunks/authThunks';

// ==============================|| APP - THEME, ROUTER ||============================== //

const AppContent = () => {
  useEffect(() => {
    store.dispatch(initializeAuth());
  }, []);

  return (
    <ThemeCustomization>
      <Routes />
      <Toaster />
    </ThemeCustomization>
  );
};

const App = () => {
  return (
    <ReduxProvider store={store}>
      <AppContent />
    </ReduxProvider>
  );
};

export default App;